module.exports = __webpack_public_path__ + "img/title-shiba.8bafb738.png";